import { filter } from 'rxjs/operators';
import { Component, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { EmailStatus } from '../../model/const/enums';
import { Email } from '../../model/email';
import { EmailService } from '../../service/data/email.service';
import { standardCommand } from '../../../core/model/command';
import { Observable } from 'rxjs';
import { FileService } from '../../../core/service/file.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { LanguageService } from '../../../core/service/language.service';

@Component({
    selector: 'app-send-generic-email-form',
    templateUrl: './send-generic-email-form.component.html',
    styleUrls: ['./send-generic-email-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendGenericEmailFormComponent extends FormComponentBase<Email> {
  constructor(
    private _messageDispather: ComponentMessageDispatcher,
    activatedRoute: ActivatedRoute,
    dispatcher: CommandDispatcher,
    private languageService: LanguageService,
    protected fb: FormBuilder,
    protected fc: FormControlExFactory,
    handlerResolver: CommandHandlerResolver,
    protected service: EmailService,
    messageService: MessageService,
    navigation: NavigationService,
    private _router: Router,
    private _route: ActivatedRoute
  ) {
    super(activatedRoute, service, messageService, navigation, dispatcher, handlerResolver);
    this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);

    this.getRecepientFromUrl();
  }

  // ngOnInit(): void {
  // }

  recipients: any[];
  showRecipients: boolean = false;
  showPreview = false;

  get canSend(): boolean {
    return this.form && this.form.valid;
  }
  get showSend(): boolean {
    return this.dataContext && this.dataContext.status === EmailStatus.Created;
  }

  protected createModel(): Email {
    return new Email();
  }

  protected getFormGroup(): FormGroup {
    return this.fb.group({
      body: this.fc.createMandatory('MAIL_FORM.BODY_SMS_LABEL', this.dataContext.body),
      subject: this.fc.createMandatory('MAIL_FORM.HEADER_LABEL', this.dataContext.subject),
      attachments: this.fb.array([]),
    });
  }

  protected init(emailMessage: Email) {
    super.init(emailMessage);
  }

  private _getFormData() {
    let data = this.form.value;
    data.attachments = (this.form.controls['attachments'] as FormArray).controls.map(f => f.value.data);
    data.recipientEmailAddresses = this.recipients.map(r => r.recipientName);
    return data;
  }

  getRecepientFromUrl() {
    let recipient = this._route.snapshot.queryParams['tmpusr'];
    if (!recipient) return;
    this.recipients = [{ recipientName: recipient }];
    this.showRecipients = true;
  }

  removeRecipient(recipient, index: number) {
    let message = this.languageService.instant('COMMON.CONFIRM_REMOVE_FROM_LIST');
    if (!confirm(message.replace('{{x}}', recipient.recipientName))) return;
    this.recipients.splice(index, 1);
  }

  cancel() {
    this.navigation.navigateBack();
  }

  onSubmit(): void {
    if (this.form.invalid || this.form.pristine || this.form.disabled) return;
    this.form.disable();
    this.AddSubscription(
      this.service.sendEmails(this._getFormData()).subscribe(
        () => {
          this.formSubmitted();
          this.messageService.showSuccess('SUCCESS.EMAIL_SENT');
          this.navigation.navigateBack();
        },
        error => {
          this.messageService.showError(error);
          this.form.enable();
        }
      )
    );
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    //
    // Avoid save changes message
    //
    return true;
  }
}
